import styled, { css } from 'styled-components';

import colors from '~/styles/colors';
import grid from '~/styles/grid';

interface SubtitleImageProps {
  size?: 'md' | 'lg';
}

interface SubtitleTextProps {
  color: string;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 0;
  cursor: pointer;
  margin: 0 4%;

  @media (max-width: 1400px) {
    margin-left: 3%;
  }
`;

export const CollapseHeader = styled.div`
  background: ${colors.primary};
  color: ${colors.white};
  font-size: 12px;
  border-radius: 5px 5px 0px 0px;
  display: flex;
  padding: 0 5px 0 5px;
  margin: 0 ${grid['6xl']};
  width: 170px;
`;

export const CollapseContent = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
  gap: ${grid.sm};
  box-shadow: -3px 0px 6px #00000029;
  border-radius: 10px 10px 0px 0px;
  width: 100%;
  height: 250px;
  padding-left: 16px;

  @media (max-width: 1400px) {
    width: 95%;
  }
`;

export const SubtitleContainer = styled.div`
  display: flex;
  column-gap: 16px;
  row-gap: 8px;
  color: #999999;
  width: 760px;
  flex-wrap: wrap;
  align-items: center;
`;

export const Subtitle = styled.div`
  display: flex;
  height: ${grid['6xl']};
  width: 220px;
  align-items: center;
`;

export const SubtitleImage = styled.div<SubtitleImageProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 62px;
    height: 62px;
    ${(props) =>
      props.size === 'md' &&
      css`
        width: 42px;
        height: 42px;
      `}
  }

  @media (max-width: 1400px) {
    img {
      width: 52px;
      height: 52px;
      ${(props) =>
        props.size === 'md' &&
        css`
          width: 32px;
          height: 32px;
        `}
    }
  }
`;

export const SubtitleText = styled.div<SubtitleTextProps>`
  margin-left: 8px;

  span {
    margin-bottom: 16px;
    color: ${(props) => props.color};
    font-size: 11px;
  }

  p {
    font-size: 11px;
  }
`;

export const SubtitleIcon = styled.div`
  display: flex;
  align-items: center;
  gap: ${grid.xs};
`;

export const SubtitleSpan = styled.span``;
